import {Component, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {CentreService} from "../../../../services/centre.service";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {ViewChild, ElementRef} from '@angular/core';
import jsPDF from 'jspdf';

import html2pdf from 'html2pdf.js';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexStroke,
  ApexFill,
  ApexTooltip,
  ApexTitleSubtitle,
  ApexGrid,
  ApexMarkers,
  ApexNonAxisChartSeries,
  ApexResponsive,
} from 'ng-apexcharts';
import {ChartConfiguration} from "chart.js";
import {FullChild} from "../../../../interfaces/FullChild";
import {AngularFirestore, AngularFirestoreCollection} from "@angular/fire/compat/firestore";
import {ChildService} from "../../../../components/child/child.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {ChangeEvent} from "@ckeditor/ckeditor5-angular";
import {DomSanitizer} from "@angular/platform-browser";
import {MatSelect, MatSelectChange} from "@angular/material/select";
import {PhotoGalleryComponent} from "../../../../components/photo-gallery/photo-gallery.component";
import {MatDialog} from "@angular/material/dialog";
import Editor from "@ckeditor/ckeditor5-build-classic";
import {endOfDay} from '../../../../utils/date-range-format.service';



export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  colors: string[];
  yaxis: ApexYAxis;
  grid: ApexGrid;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-view-impact-reports',
  templateUrl: './view-impact-reports.component.html',
  styleUrls: ['./view-impact-reports.component.scss']
})
export class ViewImpactReportsComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  @ViewChild('content') content!: ElementRef;
  mStartDate: null | Date = null
  mEndDate: null | Date = null
  singleCount = 0
  childrenCount = 0
  mTotalIndividualSession = 0
  baselineArray: any[] = []
  dischargeArray: any[] = []
  public areaChartOptions!: Partial<ChartOptions>;
  mALanguageAverage = 0
  mDLanguageAverage = 0
  mAMathsAverage = 0
  mDMathsAverage = 0
  mAEvsAverage = 0
  mDEvsAverage = 0
  dbType: any;
  storagePath: any;
  centres$: Observable<Centre[]>;
  selectedCentre = "All";
  showDelete = true

  path: any
  mData: any
  selectedChildCode?: any;
  childBycentre: Observable<FullChild[]> | undefined;
  educationData: any
  mShowChart = false
  editorData: any
  public Editor: any = ClassicEditor;
  @ViewChild('selectElement') selectElement!: MatSelect;
  mCentre?: Centre
  mCentres?: Centre[] = []
  selectedSubmit: any;
  colors: any[] = [{backgroundColor: ["#0b5ba8", "#6114be", "#15dcdc"]}];
  mTotalSessions = 0;
  mTeacherSessions = 0;
  mTeacherSessionsGroup = 0;
  mVolunteerSessions = 0;
  mVolunteerSessionsGroup = 0;
  mDaysObserved = 0;
  highlights: any = '';
  mId: string | undefined
  selectedImages: string[] = [];
  selectedImages1: string[] = [];
  selectedImages2: string[] = [];
  mTotalAdmissions: number = 0
  mTotalDischarge: number = 0
  mTotalUnits: number | undefined = 0
  private mTotalAdmissions$: Observable<FullChild[]> | undefined;
  private mTotalDischarge$: Observable<FullChild[]> | undefined;
  selectedGalleryImages: string[] = [];
  galleryImagesEdu: any[] = [];
  galleryImagesCelebration: any[] = [];
  galleryImagesVolunteering: any[] = [];
  selectedImagesEdu: string[] = [];
  selectedImagesCelebration: string[] = [];
  selectedImagesVolunteering: string[] = [];
  previewImageUrl: string | null = null;
  showPreview: boolean = false;
  reportType: string | undefined;

  constructor(
      private mCentreService: CentreService,
      private mSnackbar: MatSnackBar,
      private mFirestore: AngularFirestore,
      private route: ActivatedRoute,
      private sanitizer: DomSanitizer,
      private readonly router:Router,
      private childService: ChildService,
      private matDialog: MatDialog) {
    this.centres$ = this.mCentreService.getAllCentres();
    this.centres$.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.mCentres = res;
      if (this.selectedCentre && this.selectedCentre !== 'All') {
        this.mCentre = res.find(x => x.centreCode === this.selectedCentre);
      }
    })
    this.areaChartOptions = {
      series: [

        {
          name: 'Written',
          data: [0, 0, 0],
        },
        {
          name: 'Oral',
          data: [0, 0, 0],
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
          show: false,
        },
        foreColor: '#9aa0ac',
      },
      colors: ['#0e28a6', '#e83108'],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: ['Language', 'Maths', 'EVS/GK'],
        // categories: [
        //     '2018-09-19',
        //     '2018-09-20',
        //     '2018-09-21',
        //     '2018-09-22',
        //     '2018-09-23',
        //     '2018-09-24',
        //     '2018-09-25',
        // ],
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
    route.params.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.mId = res['id']
      console.log("mid", this.mId)

      if (this.mId) this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
        if (this.mId != undefined) {
          this.mData = res
          this.mTotalSessions = res.totalSessions
          this.mTotalAdmissions = res.totalAdmissions
          this.mTotalDischarge = res.totalDischarge
          this.changeSelectedOption(res.centreCode)
          this.mTeacherSessions = res.teacherSessions
          this.mTeacherSessionsGroup = res.teacherSessionsGroup
          this.mDaysObserved = res.daysObserved
          this.mVolunteerSessions = res.volunteerSessions
          this.mVolunteerSessionsGroup = res.volunteerSessionsGroup
          this.highlights = res.highlights
          this.editorData = res.highlights
          this.reportType = res.reportType || 'Monthly'
          this.mStartDate = res.from.toDate()
          this.mEndDate = res.to.toDate()
          this.selectedCentre = res.centreCode
          this.mCentre = this.mCentres?.filter(x => x.centreCode == res.centreCode)[0]

          // Load uploaded photos
          const img = res.image || {};
          this.selectedImagesEdu = img.education || [];
          this.selectedImagesCelebration = img.celebration || [];
          this.selectedImagesVolunteering = img.volunteering || [];

          // Load gallery images (supports both old flat-array and new object format)
          const gi = res.galleryImages || {};
          if (Array.isArray(gi)) {
            this.galleryImagesEdu = gi;
            this.galleryImagesCelebration = [];
            this.galleryImagesVolunteering = [];
          } else {
            this.galleryImagesEdu = gi.education || [];
            this.galleryImagesCelebration = gi.celebration || [];
            this.galleryImagesVolunteering = gi.volunteering || [];
          }

          if (this.hasChartData(res.baseline, res.discharge)) {
            this.showChartfromData(this.mData)
          } else {
            this.mShowChart = false
          }

        }
      })
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  selectFile($event: Event) {

  }

  upload() {

  }

  search() {
    // alert('this.mTeacherSessions')

    if (this.selectedCentre != null) {
      this.childBycentre = this.childService.getAllotedChildListByCenterAboveThree(this.selectedCentre!)
      this.childBycentre.pipe(takeUntil(this._destroyed$)).subscribe(res => {
        this.mTeacherSessions = res.length
        // alert('this.mTeacherSessions')
        // alert(this.mTeacherSessions)
      })
    }

  }

  searchChild() {
    this.mVolunteerSessions = 0
    this.mTotalSessions = 0

    let childObject = {
      'childCode': this.selectedChildCode.childCode,
      'childName': this.selectedChildCode.firstName + ' ' + this.selectedChildCode.lastName,
      'parentsName': this.selectedChildCode.guardians[0]?.firstName + 'and ' + this.selectedChildCode.guardians[1]?.firstName,
    }

    this.mFirestore.collection(this.env.education,
        ref => ref.where('childCode', '==', this.selectedChildCode.childCode)
    )
        .valueChanges({idField: 'id'})
        .pipe(takeUntil(this._destroyed$))
        .subscribe(res => {
          if (res) {
            // console.log('PAVAN :=> ' + res)
            res.filter((x: any) => x.volunteerName != '' || x.volunteerName != null)
            this.educationData = res
            this.mTotalSessions = res.length
            if (this.educationData) this.educationGraph()
          }
        })
    this.mFirestore.collection(this.env.educationGroup, ref => ref.where('volunteerName', '!=', null)
        .where('volunteerName', '!=', '')
    ).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe(res => {
      res.forEach((session: any) => {
        session.children.forEach((child: { child: any; }) => {
          if (child.child == this.selectedChildCode.childCode) this.mTotalSessions++
        })
      })
    })
  }

  private educationGraph() {
    this.baselineArray = [this.mALanguageAverage, this.mAMathsAverage, this.mAEvsAverage]
    this.dischargeArray = [this.mDLanguageAverage, this.mDMathsAverage, this.mDEvsAverage]
    this.areaChartOptions = {
      series: [
        {
          name: 'Baseline',
          data: [this.mALanguageAverage, this.mAMathsAverage, this.mAEvsAverage],
        },
        {
          name: 'Discharge',
          data: [this.mDLanguageAverage, this.mDMathsAverage, this.mDEvsAverage]
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
          show: false,
        },
        foreColor: '#9aa0ac',
      },
      colors: ['#0e28a6', '#e83108'],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: ['Language', 'Maths', 'EVS/GK'],
        // categories: [
        //     '2018-09-19',
        //     '2018-09-20',
        //     '2018-09-21',
        //     '2018-09-22',
        //     '2018-09-23',
        //     '2018-09-24',
        //     '2018-09-25',
        // ],
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
    console.log('ssdsd', isNaN(this.mDLanguageAverage))
    console.log('ssdsd', isNaN(this.mDMathsAverage))
    console.log('ssdsd', isNaN(this.mDEvsAverage))

    if (!this.hasChartData(this.baselineArray, this.dischargeArray)) {
      this.mSnackbar.open('No discharge assessment found', '', {
        panelClass: 'error',
        duration: 3000
      });
      this.mShowChart = false;
    } else {
      this.mShowChart = true;
    }
  }


  save() {

    let obj = {
      highlights: this.highlights.toString(),
      teacherSessions: this.mTeacherSessions,
      volunteerSessions: this.mVolunteerSessions,
      daysObserved: this.mDaysObserved,
      centreCode: this.selectedCentre,
      totalSessions: this.mTotalSessions,
      totalUnits: this.mTotalUnits,
      totalAdmissions: this.mTotalAdmissions,
      totalDischarge: this.mTotalDischarge,
      from: this.mStartDate,
      to: this.mEndDate,
      createdAt: new Date(),
      baseline: this.baselineArray,
      discharge: this.dischargeArray,
      submitType: this.selectedSubmit,
      image: {
        education: this.selectedImagesEdu,
        celebration: this.selectedImagesCelebration,
        volunteering: this.selectedImagesVolunteering,
      },
      galleryImages: {
        education: this.galleryImagesEdu,
        celebration: this.galleryImagesCelebration,
        volunteering: this.galleryImagesVolunteering,
      },
    }

    console.log(obj)

    if (this.selectedCentre == '' ||
        this.selectedCentre == null ||
        this.mStartDate == null ||
        this.mEndDate == null
    ) {
      this.mSnackbar.open('Please enter all fields', "", {
        panelClass: 'snackbar-error',
        duration: 3000
      })
      return
    }
    if (this.mId != undefined) {
      this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId).update(obj).then(() => {
        this.mSnackbar.open('Report Saved Successfully')._dismissAfter(3000)
        this.printDoc()
        this.router.navigate(['home/reports/impact-report-table]'])

      })
    } else if (this.mId == undefined) {
      this.mFirestore.collection(this.env.educationImpactReport).add(obj).then(() => {
        this.mSnackbar.open('Report Saved Successfully')._dismissAfter(3000)
        // this.printDoc()
        this.router.navigate(['home/reports/impact-report-table'])


      })
    }

  }

  printDoc() {
    let printContents;
    const previewElement = document.getElementById('preview');
    if (previewElement) {
      printContents = previewElement.innerHTML;
    } else {
      console.error('Element with ID "preview" not found.');
      return; // Exit the function if the element is not found
    }

    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
                    <html>
                        <head>
                            <title>Education-Impact-Report</title>
                            <style>
                                @media print {
                        body{
                        margin: 0;
                        padding: 0;
                        }
                            .page{
                            position: relative;
                            padding: 20px;
                            margin: 10px;
                            box-sizing: border-box;
                            page-break-after: always;
                            }

                            .page:before{
                            content:'';
                            display:block;
                            position:fixed;
                            top:0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            border: 1px solid #000000;
                            box-sizing: border-box;
                            pointer-events: none;
                            z-index: -1;
                            }
                        }
                            </style>
                        </head>
                        <body onload="window.print(); window.close();">
                           <div class="page">
                ${printContents}
                </div>
                        </body>
                    </html>
                `);
      popupWin.document.close();
    } else {
      console.error('Popup window could not be opened.');
    }

  }

  // Chart is only worth showing when at least one of the baseline/discharge scores is a real, non-zero number
  private hasChartData(baseline: number[] | undefined, discharge: number[] | undefined): boolean {
    const hasValue = (arr: number[] | undefined) =>
      !!arr?.length && arr.some(v => !isNaN(v) && v !== 0);
    return hasValue(baseline) || hasValue(discharge);
  }

  private showChartfromData(mData: any) {
    const discharge: number[] = mData.discharge || [];
    const baseline: number[] = mData.baseline || [];
    if (!this.hasChartData(baseline, discharge)) {
      this.mShowChart = false;
      return;
    }

    this.areaChartOptions = {
      series: [
        {
          name: 'Baseline',
          data: mData.baseline,
        },
        {
          name: 'Discharge',
          data: mData.discharge
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
          show: false,
        },
        foreColor: '#9aa0ac',
      },
      colors: ['#0e28a6', '#e83108'],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: ['Language', 'Maths', 'EVS/GK'],
        // categories: [
        //     '2018-09-19',
        //     '2018-09-20',
        //     '2018-09-21',
        //     '2018-09-22',
        //     '2018-09-23',
        //     '2018-09-24',
        //     '2018-09-25',
        // ],
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
    this.mShowChart = true
  }

  Search() {
    this.mTotalAdmissions = 0
    this.mTotalDischarge = 0
    this.mVolunteerSessions = 0
    this.mVolunteerSessionsGroup = 0
    this.mTotalSessions = 0
    this.mTeacherSessions = 0
    this.mTeacherSessionsGroup = 0
    let t = 0
    if (this.mStartDate != null && this.mEndDate != null) this.mFirestore.collection(this.env.education, ref => ref.where('centreCode', '==', this.selectedCentre).where('sessionDate', '>=',
        this.mStartDate).where('sessionDate', '<=', endOfDay(this.mEndDate))
        .where('present', '==', 'Present')
    )
        .valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
          console.log(`totalSessions = ${res.length}`)
          let s = res.filter((x: any) => x.volunteerName == '' || x.volunteerName == null)
          this.mVolunteerSessions = res.filter((x: any) => x.volunteerName != '').length
          this.mTeacherSessions = s.length
          this.educationData = res
          this.getTotalBaselines(this.educationData)
          this.getTotalDischarges(this.educationData)
          this.educationGraph()
          // console.log("res", res)
        })
    if (this.mStartDate != null && this.mEndDate != null) this.mFirestore.collection(this.env.educationGroup, ref => ref.where('centres', 'array-contains', {
      centreName: this.mCentre?.centreName!!,
      centreCode: this.mCentre?.centreCode!!
    }).where('sessionDate', '>=', this.mStartDate).where('sessionDate', '<=', endOfDay(this.mEndDate)))
        .valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
          t = 0
          this.singleCount = 0
          this.childrenCount = 0
          this.mVolunteerSessionsGroup = 0
          // alert( 'ds'+ res.length)
          console.log(`totalSessions = ${res.length}`)
          // this.mTotalSessions = res.length
          // this.mVolunteerSessions = res.filter((x: any) => x.volunteerName != '').length
          this.educationData = res
          // alert(this.educationData.length)
          this.educationData.forEach((it: any) => {

            if (it.countType == 'bysession') {
              this.singleCount++
            } else if (it.countType == 'bychildren') {
              this.childrenCount += it.children.length
            }

            t = this.singleCount + this.childrenCount
            this.mVolunteerSessionsGroup = t
            // console.log('xxxx', this.mVolunteerSessions)
            this.mTeacherSessionsGroup = res.filter((s: any) => s.volunteerName == '').length

          })

          // this.getTotalBaselines(this.educationData)
          // this.getTotalDischarges(this.educationData)
          // this.educationGraph()
          // console.log("res", res)
        })


    if (this.selectedCentre != null && this.mStartDate != null && this.mEndDate != null) {
      console.log("in total admission")
      this.mTotalAdmissions$ = this.mFirestore.collection<FullChild>('ALChild',
          ref => ref.where('centreCode', '==', this.selectedCentre)
      ).valueChanges()
      this.mTotalAdmissions$.pipe(takeUntil(this._destroyed$)).subscribe(res => {
        res.forEach(child => {
          child.admissionData.forEach((admission, i) => {
            if (child.admissionData.length >= 1) {
              if (i == 0) {
                if (admission.dateOfAdmission?.toDate()! >= this.mStartDate!! && admission.dateOfAdmission?.toDate()! <= this.mEndDate!!) this.mTotalAdmissions += 1
              }
            }
          })
        })
      })
      this.mTotalDischarge$ = this.mFirestore.collection<FullChild>('ALChild',
          ref => ref.where('centreCode', '==', this.selectedCentre))
          .valueChanges()
      this.mTotalDischarge$.pipe(takeUntil(this._destroyed$)).subscribe(res => {
        // alert(res.length)
        res.forEach(child => {
          if (child.admissionData.length > 1 && child.admissionData[1].dateOfDischarge!!.toDate() >= this.mStartDate!! && child.admissionData[1].dateOfDischarge!!.toDate() <= this.mEndDate!!) {
            this.mTotalDischarge += 1
            // console.log('found  ',this.mTotalDischarge  )
          }
        })
      })
    }
    if (this.mStartDate != null && this.mEndDate != null) {
      const monthCount = this.calculateMonthDifference(this.mStartDate, this.mEndDate);
      this.mDaysObserved = monthCount
    }
    this.mTotalIndividualSession = this.mTeacherSessions + this.mTeacherSessionsGroup - this.mDaysObserved
  }

  private getTotalBaselines(mData: any) {
    this.mALanguageAverage = 0
    this.mAMathsAverage = 0
    this.mAEvsAverage = 0
    let mLanguageTotal = 0
    let mMathsTotal = 0
    let mEvsTotal = 0
    const mBaselines = mData.filter((x: any) => x.sessionType == 'Baseline Assessment')
    console.log('Baselines')
    mBaselines.forEach((it: any) => {
      if (it.languageOral && it.languageWritten) mLanguageTotal += (Number(it.languageOral) + Number(it.languageWritten))
      if (it.mathsOral && it.mathsWritten) mMathsTotal += (Number(it.mathsOral) + Number(it.mathsWritten))
      if (it.evsgkOral && it.evsgkWritten) mEvsTotal += (Number(it.evsgkWritten) + Number(it.evsgkOral))
    })
    this.mALanguageAverage = Number((mLanguageTotal / mBaselines.length).toFixed(2))
    // this.mALanguageAverage = (mLanguageTotal / mBaselines.length)
    this.mAMathsAverage = Number((mMathsTotal / mBaselines.length).toFixed(2))
    // this.mAMathsAverage =(mMathsTotal / mBaselines.length)
    this.mAEvsAverage = Number((mEvsTotal / mBaselines.length).toFixed(2))
    // this.mAEvsAverage = (mEvsTotal / mBaselines.length)
    console.log(`mALanguageTotal: ${mLanguageTotal}`)
    console.log(`mAMathsTotal: ${mMathsTotal}`)
    console.log(`mAEvsTotal: ${mEvsTotal}`)
    console.log(`mALanguageAverage: ${this.mALanguageAverage}`)
    console.log(`mAMathsAverage: ${this.mAMathsAverage}`)
    console.log(`mAEvsAverage: ${this.mAEvsAverage}`)
  }

  private getTotalDischarges(mData: any) {
    let mLanguageTotal = 0
    let mMathsTotal = 0
    let mEvsTotal = 0
    this.mDLanguageAverage = 0
    this.mDMathsAverage = 0
    this.mDEvsAverage = 0
    const mBaselines = mData.filter((x: any) => x.sessionType == 'Discharge Assessment')
    if (mBaselines.length == 0) this.mShowChart = false
    mBaselines.forEach((it: any) => {
      if (it.languageOral && it.languageWritten) mLanguageTotal += (Number(it.languageOral) + Number(it.languageWritten))
      if (it.mathsOral && it.mathsWritten) mMathsTotal += (Number(it.mathsOral) + Number(it.mathsWritten))
      if (it.evsgkOral && it.evsgkWritten) mEvsTotal += (Number(it.evsgkWritten) + Number(it.evsgkOral))
    })
    this.mDLanguageAverage = Number((mLanguageTotal / mBaselines.length).toFixed(2))
    this.mDMathsAverage = Number((mMathsTotal / mBaselines.length).toFixed(2))
    this.mDEvsAverage = Number((mEvsTotal / mBaselines.length).toFixed(2))
    console.log(`mALanguageTotal: ${mLanguageTotal}`)
    console.log(`mAMathsTotal: ${mMathsTotal}`)
    console.log(`mAEvsTotal: ${mEvsTotal}`)
    console.log(`mDLanguageAverage: ${this.mDLanguageAverage}`)
    console.log(`mDMathsAverage: ${this.mDMathsAverage}`)
    console.log(`mDEvsAverage: ${this.mDEvsAverage}`)
  }

  onFilesSelected(event: any) {
    const selectedFiles: FileList = event.target.files;
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles.item(i);
        if (file) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            const result = e.target.result;
            if (!this.selectedImagesEdu.includes(result)) {
              this.selectedImagesEdu.push(result);
            }
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }

  onFilesSelected1(event: any) {
    const selectedFiles: FileList = event.target.files;
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles.item(i);
        if (file) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            const result = e.target.result;
            if (!this.selectedImagesCelebration.includes(result)) {
              this.selectedImagesCelebration.push(result);
            }
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }

  onFilesSelected2(event: any) {
    const selectedFiles: FileList = event.target.files;
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles.item(i);
        if (file) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            const result = e.target.result;
            if (!this.selectedImagesVolunteering.includes(result)) {
              this.selectedImagesVolunteering.push(result);
            }
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }

  onEditorChange($event: ChangeEvent<any>) {
    console.log('editor called!!!')
    const updatedData = $event.editor.getData();
    // this.highlights =this.getSanitizedHTML(updatedData)
    this.highlights = updatedData

    console.log(updatedData);
  }

  getSanitizedHTML(htmlContent: string) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  changeSelectedOption(optionValue: string) {
    this.selectedCentre = optionValue;
    setTimeout(() => this.selectElement?.writeValue(optionValue), 0);
  }

  OnCentreChange($event: MatSelectChange) {
    this.mCentre = this.mCentres?.find(x => x.centreCode == $event.value)
    this.mCentres?.find(x => this.mTotalUnits = x.totalUnits)

  }

  selectCategory(educationSession: string) {

  }

  deleteImageFromArray(i: number, selectedImages: string[]) {
    let elementToRemove = selectedImages[i]
    let index: number = selectedImages.indexOf(elementToRemove);

    if (index !== -1) {
      selectedImages.splice(index, 1);
      console.log("Element removed successfully");
    } else {
      console.log("Element not found in the array");
    }
  }

  generatePDF() {
    const doc = new jsPDF();

    // Define the HTML content to be added to the PDF
    // @ts-ignore
    const htmlContent = document.getElementById('preview').innerHTML;

    // Add HTML content to the PDF
    doc.html(htmlContent, {
      callback: function (pdf) {
        // Save or download the PDF
        pdf.save('report.pdf');
      }
    });
  }

  openGallery() {
    const dialogRef = this.matDialog.open(PhotoGalleryComponent, {
          height: '90%',
          width: 'auto',
          data: {
            type: 'Education',
            path: `/${this.env.education}`,
            startDate: this.mStartDate,
            endDate: this.mEndDate,
            centreCode: this.selectedCentre
          }
        }
    );
    dialogRef.afterClosed().pipe(takeUntil(this._destroyed$)).subscribe((urls: string[]) => {
      if (!urls?.length) return;
      const newImages = urls.map(url => ({
        url,
        fileName: url.split('%2F').pop()?.split('?')[0] || '',
        centreName: ''
      }));
      this.galleryImagesEdu = [...this.galleryImagesEdu, ...newImages];
    });
  }

  getValues($event: MatSelectChange) {
    this.selectedSubmit = $event.value
    console.log(this.selectedSubmit)

  }

  calculateMonthDifference(startDate: Date, endDate: Date): number {
    const startMonth = startDate.getMonth();
    const startYear = startDate.getFullYear();
    const endMonth = endDate.getMonth();
    const endYear = endDate.getFullYear();
    const monthDiff = (endYear - startYear) * 12 + (endMonth - startMonth);
    return monthDiff < 0 ? 0 : monthDiff + 1;
  }

  openImagePreview(url: string) {
    this.previewImageUrl = url;
    this.showPreview = true;
  }

  closeImagePreview() {
    this.showPreview = false;
    this.previewImageUrl = null;
  }

  openImageInNewTab(url: string) {
    window.open(url, '_blank');
  }

  removeImageFromGallery(index: number, category: 'education' | 'celebration' | 'volunteering') {
    if (category === 'education') this.galleryImagesEdu.splice(index, 1);
    else if (category === 'celebration') this.galleryImagesCelebration.splice(index, 1);
    else this.galleryImagesVolunteering.splice(index, 1);
  }

}
